<template>
    <mc-drawer
        v-model="visible"
        :mask="false"
        :mask-closable="false"
        width="40%"
        class="ocr-drawer"
        @close="handleClose"
    >
        <div class="ocr-title">
            OCR结果展示（点击右键可复制信息）
            <mc-image
                style="width: 30px; height: 30px"
                src="https://p0.meituan.net/mallimages/c4a3808c213da3be352e968ad80b5ed41836868.png"
                :preview-url-list="['https://p0.meituan.net/mallimages/c4a3808c213da3be352e968ad80b5ed41836868.png']"
            />
        </div>
        <McSupplyChainOcrView
            class="ocr-view"
            type="ocr"
            :ocr-result="ocrResult"
            :original-image-src="imageSrc"
        />
    </mc-drawer>
</template>

<script>
// import '@mt-material/mc-supply-chain-components/lib/theme2/index.css';
import McSupplyChainOcrView from './McSupplyChainOcrView';

export default {
    name: 'OcrDrawer',
    components: {
        McSupplyChainOcrView,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        ocrResult: {
            type: Object,
            required: true,
        },
        imageSrc: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        visible: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        handleClose() {
            this.visible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.ocr-drawer {
    ::v-deep .mtd-drawer-wrapper {
        display: none;
    }
}
.ocr-view {
    width: 100%;
    ::v-deep img {
        width: 100% !important;
    }
}
.ocr-title {
    display: flex;
    align-items: center;
    font-size: 25px;
    font-weight: bold;
}
</style>
